define([
    "dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/action/NewController",
	"csi/def",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/html",
	"csi/resolver",
	"csi/xml",
	"Apparel/NewStyle",
	"Apparel/NewStyleForm",
	"Apparel/ProductType"
], function(array,declare,lang,csi,NewController,def,Field,Relationship,html,resolver,xml,NewStyle,NewStyleForm,ProductType) {

	var	SEASON = "ParentSeason";
	var	CATEGORY1 = "Category1";
	var	CATEGORY2 = "Category2";
	var	COLLECTION = "Collection";
	var	THEME = "Theme";
	var CREATE_COLORWAYS_FROM_THEME = "CreateColorwaysFromTheme";
	var PRODUCT_TYPE = "ProductType";
	var PRODUCT_TEMPLATE = "Template";

	var	_Form = declare(NewStyleForm, {
		/**@property override with true to avoid set the default values for theme and shape  fields in the form
		   @override */
		isShapeOrThemeContext: true,
		_addHierarchyField: function(url, id) {
			this.insertField(lang.mixin(new Field(), {
				m_id: id,
				m_bRequired: true,
				bForceEditable: true,
				bDisableExpressionEvaluation: true
			}), 0);

			if (url != csi.EMPTY_URL) {
				this.addDefaultValue(id, url);
			}
		},

		_addSeasonField: function(theme) {

			var themeSeasons = theme.ThemeSeasons;
			if (themeSeasons.length > 0) { // DE26668
				this.insertField(lang.mixin(new Field(), {
					m_id: SEASON,
					bForceEditable: true,
					m_bRequired: true,
					bDisableExpressionEvaluation: true,
					m_relationship: lang.mixin(new Relationship(), {
						m_url: theme.$URL,
						m_id: "ThemeSeasons"
					})
				}), 0);
			} else {
				this.insertField(lang.mixin(new Field(), {
					m_id: SEASON,
					bForceEditable: true,
					bDisableExpressionEvaluation: true,
					m_bRequired: true
				}), 0);
			}

			var cat1 = theme.ThemeCategory1;
			if (xml.isValidURL(cat1)) {
				var cache = this.getCache();
				cache.addNode(cat1);
				this.addDefaultValue(SEASON, cache.getNode(cat1).ParentSeason);
			} else if (themeSeasons.length >= 1) {
				this.addDefaultValue(SEASON, themeSeasons[0]);
			}
		},

		/**
		 * @override
		 * Set Theme field as read only in case NewStyleForm change the visiblity of this.
		 */
		_updateFieldVisibility: function(field) {
			this.inherited(arguments);

			this.setFieldDisabled(THEME, true);
			return true;
		},

		_resolveView: function() {
			var	fd = this.defView.m_formData;
			var	theme = fd.getParent();

			this.addFixedValue(THEME, theme.$URL);

			this._addHierarchyField(theme.ThemeCollection, COLLECTION);
			this._addHierarchyField(theme.ThemeCategory2, CATEGORY2);
			this._addHierarchyField(theme.ThemeCategory1, CATEGORY1);
			this._addSeasonField(theme);

			this.insertField(lang.mixin(new Field(), {
				m_label: CREATE_COLORWAYS_FROM_THEME,
				m_typeControl: def.FIELD_CHECKBOX,
				bPersist: true
			}));

			this.inherited(arguments);

			var	fProductType = this.defView.getField(PRODUCT_TYPE);
			fProductType.m_onChange = "_onChangeProductType";
		},

		_onChangeProductType: function(defView, field, value) {
			// summary: "Create Colorways" checkbox should be read-only and false under two conditions.
			//     1. Theme has no Theme Colorways with "available" == True.
			//     2. The style type does not support colors.
			var productType = this.defView.getField(PRODUCT_TYPE).getValue();
			var config = ProductType.getByUrl(productType);
			var canCreateColorways = this._hasAvailableColorColorwayContext(defView) && productType != null && config.HasColor;

			var fCreateColorways = this.defView.getField(CREATE_COLORWAYS_FROM_THEME);
			if(fCreateColorways) {
				html.setDisabled(fCreateColorways.m_control, !canCreateColorways);
				if(!canCreateColorways)
					this.setFieldValue(fCreateColorways, false);
			}
		},

		_hasAvailableColorColorwayContext: function(defView) {
			var	theme = defView.m_formData.getParent();
			var colorColorways = theme.ColorColorways;
			var availableColorColorways = array.some(colorColorways, function(ccc) {
				var ccNode = resolver.resolveNode(ccc, true);
				return ccNode && ccNode.Available;
			});

			return availableColorColorways;
		}
	});

	return declare(NewStyle, {
		/**
		 * Add special controller for Style create form
		 */
		onCreatePopupDefView: function(defView) {
			defView.classController = _Form;
		},

		toWriterRequest: function() {
			// summary: "use" hierarchy fields so they won't be published to server
			var	fd = this.getFormData();
			var urlCollection = fd.getFieldValue(COLLECTION, true);
			fd.getFieldValue(SEASON, true);
			fd.getFieldValue(CATEGORY1, true);
			fd.getFieldValue(CATEGORY2, true);

			var urlTheme = fd.getFieldValue(THEME, true);
			var createColorways = fd.getFieldValue(CREATE_COLORWAYS_FROM_THEME, true);

			var	call = NewController.prototype.toWriterRequest.call(this);
			call
				.addParameter(PRODUCT_TYPE, xml.ATTR_REF, fd.getFieldValue(PRODUCT_TYPE, true))
				.addParameter(PRODUCT_TEMPLATE, xml.ATTR_REF, fd.getFieldValue(PRODUCT_TEMPLATE, true))
				.addParameter(xml.ATTR_NAME, xml.ATTR_STRING, fd.getFieldValue(xml.ATTR_NAME, true))
				.addParameter("CollectionURL", xml.ATTR_REF, urlCollection)
				.addParameter(CREATE_COLORWAYS_FROM_THEME, xml.ATTR_BOOLEAN, createColorways);

            return call;
		}
	});
});